<main>
    <div class="jeux_left">
        <app-menus></app-menus>
    </div>
    <div class="jeux_right">
      <div class="activityImg_ctn">
        <img src="{{activityPhotoUrl}}">
        <div class="activity_overlay" style="background-color: #{{color}}; opacity: 0.7;"></div>
        <h2>{{activityName}}</h2>
      </div>
      <div class="activity_timer_ctn">
        <div class="timer">
          <h1 class="jeux_minutes">00</h1><h1>:</h1><h1 class="jeux_secondes">00</h1>
        </div>
        <div class="manuelMinuteur_ctn">
          <mat-icon class="watch" aria-hidden="false" (click)="manageManualTimerModal()">av_timer</mat-icon>
          <p>(icône d’ajout de temps manuellement)</p>
        </div>
        <button class="commencer_btn" (click)="minuteur()" style="background-color: #{{color}};">Commencer !</button>
      </div>
      <div class="choiceModal" style="display: flex;">
        <h2>J'accumule des Étoiles pour</h2>
        <div *ngIf="userType =='participant'" class="choice_btns_ctn">
          <div class="choice" (click)="choiceChosen($event,'1')"><p>moi</p></div>
          <div class="choice" (click)="choiceChosen($event,'2')"><p>moi et ma famille</p></div>
          <div *ngIf="isUserClassesEmpty == false" class="choice" (click)="choiceChosen($event, userDataClasses[0])">
            <p>moi et ma classe</p>
          </div>
        </div>
        <div *ngIf="userType !='participant'" class="choice_btns_ctn">
          <div class="choice" (click)="choiceChosen($event,'1')"><p>moi</p></div>
          <div *ngFor = "let classe of userClasses | async | slice:0:5" class="choice" (click)="choiceChosen($event, classe.code_ref)">
            <p>moi et ma classe: {{classe.nom}}</p>
          </div>
        </div>
        <button (click)="manageChoiceModal()">Commencer!</button>
      </div>
      <div class="minuteurManuel">
        <mat-icon class="icon_close" (click)="manageManualTimerModal()" aria-hidden="false">close</mat-icon>
        <mat-form-field>
            <mat-label>Inscrivez combien de minutes vous avez été actif</mat-label>
            <input type="text" matInput placeholder="15" [(ngModel)]="minutes">
        </mat-form-field>
        <button (click)="getManualStars()">Terminer</button>
      </div>
    </div>
  </main>